import React, { memo } from "react";
import { Button } from "@material-ui/core";

// props are spread as below directly to prevent inconsistent look of the buttons
// do not modify; if needed to have other look, use standard Button component
// or create other custom button wrapper
function DialogCancelButton({ color, variant, className, ...rest }) {
  return <Button color="secondary" {...rest} />;
}
export default memo(DialogCancelButton);
